import { render } from "./MyPageAuth.vue?vue&type=template&id=42d21fc8&scoped=true&ts=true"
import script from "./MyPageAuth.vue?vue&type=script&lang=ts"
export * from "./MyPageAuth.vue?vue&type=script&lang=ts"

import "./MyPageAuth.vue?vue&type=style&index=0&id=42d21fc8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42d21fc8"]])

export default __exports__